import React, { useState } from 'react';
import { useSubscription } from '@apollo/client';
import { ProfileQL } from '../../models/Profile';
import { ReportProgressSubscription } from '../../models/Subscriptions';
import { graphqlSchema } from '../../services/graphql.schema';

import './ReportProgress.notifications.scss';
import { Link } from 'react-router-dom';

interface ReportProgressNotificationProps {
    currentUser: ProfileQL;
}

export default function ReportProgressNotification({ currentUser }: ReportProgressNotificationProps) {

    const [reportBuildProgress, setReportBuildProgress] = useState<ReportProgressSubscription>(null);

    useSubscription<{ reportBuildProgress: ReportProgressSubscription }>(graphqlSchema.PROFILE.REPORTS.reportBuildProgress, {
        onSubscriptionData: ({ subscriptionData }) => {
            console.log('reportBuildProgress noti: ', subscriptionData);
            const reportBuildProgress:ReportProgressSubscription = subscriptionData.data.reportBuildProgress;
            setReportBuildProgress(reportBuildProgress);
        }
    });

    const goToReport = () => {
        setTimeout(() => {
            setReportBuildProgress(null);
        }, 1500)
    }

    if (!currentUser?.izettleProfile || !reportBuildProgress) {
        return (<div id="PROGRESS_NOTIFICATIONS"></div>)
    }
    
    const stateLabel = (repProgress: ReportProgressSubscription) => {
        if(!!repProgress.productsProgress){
            return `Obteniendo productos: ${repProgress.productsProgress.fetched || 0} / ${repProgress.ordersFetchProgress.fetched } hasta ahora`
        }
        if(!!repProgress.billsProgress){
            return `Obteniendo facturas: ${repProgress.billsProgress.fetched || 0} hasta ahora`
        }
        if(!!repProgress.ordersBindedProgress){
            return `Procesando pedidos: ${repProgress.ordersBindedProgress.fetched || 0} hasta ahora`
        }
        if(!!repProgress.ordersFetchProgress){
            return `Obteniendo pedidos: ${repProgress.ordersFetchProgress.fetched || 0} hasta ahora`
        }
    }

    return (
        <div id="PROGRESS_NOTIFICATIONS">
            <div className={`_entry ${!!reportBuildProgress.dataUrl ? 'ready' : ''}`}>
                <div className="_icon">
                    <span className="material-icons">
                        check_circle
                    </span>
                </div>
                <div className="progressText">
                    <p>
                        {reportBuildProgress.dataUrl ? 'Reporte listo!' : (reportBuildProgress.working ? 'Reporte en progreso' : 'Reporte por iniciar')}
                    </p>
                    <p className="stage">
                        {stateLabel(reportBuildProgress)}
                    </p>
                </div>
                <Link to={`/ordenes/report/generation/${reportBuildProgress._id}`} onClick={goToReport}>
                    <span>
                        Ver
                    </span>
                </Link>
            </div>
        </div>
    )
}